const DEFAULT_TRUNCATE_SYMBOL = '…';
// Limit emails to no more than about 600 chars, well over the max of ~300.
// cf. RFC: https://www.rfc-editor.org/errata_search.php?eid=1690
const URL_REGEX =
  /(((ftp|https?):\/\/)[\-\w@:%_\+.~#?,&\/\/=]+)|((mailto:)?[_.\w-]{1,300}@(.{1,300}\.)[a-zA-Z]{2,3})/g;

// @ts-ignore
// eslint-disable-next-line @typescript-eslint/naming-convention
function __appendEllipsis(string: string, options: any, content: string): string {
  if (content.length === string.length || !options.ellipsis) {
    return content;
  }
  content += options.ellipsis;
  return content;
}

/**
 * Truncate HTML string and keep tag safe.
 *
 * @param {string} string string needs to be truncated
 * @param {number} maxLength length of truncated string
 * @param {object} [options] (optional)
 * @param {boolean|string} [options.ellipsis] omission symbol for truncated string, '...' by default
 * @return {string} truncated string
 */
function truncate(
  string: string,
  maxLength: number,
  options?: { ellipsis?: boolean | string },
): string {
  let content = ''; // truncated text storage
  let matches = true;
  let remainingLength = maxLength;
  let result: RegExpExecArray | null;
  let index: number;

  options = options || {};
  options.ellipsis =
    typeof options.ellipsis === 'undefined' ? DEFAULT_TRUNCATE_SYMBOL : options.ellipsis;

  if (!string || string.length === 0) {
    return '';
  }

  matches = true;
  while (matches) {
    URL_REGEX.lastIndex = content.length;
    // @ts-ignore
    matches = URL_REGEX.exec(string);

    // Don't try to retain URLs longer than 3k chars, well over the 99th percentile of ~347
    if (
      !matches ||
      // @ts-ignore
      matches.index - content.length >= remainingLength ||
      URL_REGEX.lastIndex >= maxLength + 3000
    ) {
      content += string.substring(content.length, maxLength);
      return __appendEllipsis(string, options, content);
    }

    result = matches[0];
    // @ts-ignore
    index = matches.index;
    // @ts-ignore
    content += string.substring(content.length, index + result.length);
    // @ts-ignore
    remainingLength -= index + result.length;

    if (remainingLength <= 0) {
      break;
    }
  }

  return __appendEllipsis(string, options, content);
}

export default truncate;
